<template>
  <div class="mobile-nav h-full w-full absolute top-0 bottom-0 z-40">
    <PageNavigation/>
    <SubPageNavigation/>
    <MicroPageNavigation/>
  </div>
</template>

<script>
import PageNavigation from './Mobile/PageNavigation.vue';
import SubPageNavigation from './Mobile/SubPageNavigation.vue';
import MicroPageNavigation from './Mobile/MicroPageNavigation.vue';

export default {
  name: 'MobileNavigation',
  components: {
    PageNavigation,
    SubPageNavigation,
    MicroPageNavigation,
  },
};
</script>

<style scoped lang="scss">
.mobile-nav {
  width: 100%;
  @media (min-width: 700px) {
    width: 70%;
    border-right: 1px solid #ccc;
  }
}
</style>
